<template>
    <v-dialog v-model="dialogIcon" ref="modal" @keydown.esc="clearFields()" persistent max-width="700px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" tile outlined class="ml-0 white--text" color="primary" @click="teste()">
                Selecione um Ícone
            </v-btn>
            <v-icon class="ml-3"> {{selIcon}} </v-icon>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Selecione o Icone que deseja Utilizar </span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-divider></v-divider>            
            <v-card-text>
                <v-row>
                    <v-col v-for="icon in icons" :key="icon" cols="2" sm="2">
                        <v-btn class="ma-2" tile large icon @click="iconSelected(icon)">
                            <v-icon>{{icon}}</v-icon>
                        </v-btn>
                    </v-col>                      
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'SelIcon',
    props: ['iconStart'],
    data: () => ({
        dialogIcon: false,
        loading: false,
        selIcon: 'mdi-plus',
        icons: ['mdi-hanger','mdi-tshirt-crew','mdi-tshirt-crew-outline','mdi-cup-water','mdi-food-fork-drink','mdi-glass-mug-variant',
                'mdi-beer','mdi-beer-outline','mdi-food','mdi-food-apple','mdi-food-apple-outline','mdi-food-croissant',
                'mdi-bread-slice','mdi-cake-variant','mdi-baguette','mdi-bottle-wine','mdi-cheese','mdi-coffee',
                'mdi-cookie','mdi-fish','mdi-glass-wine','mdi-noodles','mdi-pasta','mdi-muffin',
                'mdi-shopping-outline','mdi-silverware-fork-knife','mdi-cart','mdi-gift-outline','mdi-basket','mdi-shopping',
                'mdi-storefront-outline','mdi-store','mdi-glasses','mdi-bow-tie','mdi-hat-fedora','mdi-lingerie',
                'mdi-necklace','mdi-shoe-formal','mdi-shoe-heel','mdi-tie','mdi-sunglasses','mdi-laptop',
                'mdi-headphones','mdi-cellphone-android','mdi-watch','mdi-radio'],
        nome: "",
        status:false,
        maior: false,
    }),
    created()
    {   
        if(typeof this.iconStart != "undefined")
            this.selIcon = this.iconStart        
    },    
    methods: {
        clearFields(){
            this.nome = null,
            this.status = null,
            this.maior = null,
            this.dialogIcon = false
        }, 
        iconSelected(value){
            this.selIcon = value
            this.dialogIcon = false
            this.$emit('iconSelect',value)
        }             
    },
}
</script>
